<ef-loading [loading]="loading$ | async" [processing]="processing$" [loadingText]="loadingText$ | async"></ef-loading>
